export default __webpack_public_path__ + "static/media/425.20331f65.jpg";